<template>
    <modal name="cupomHistorico" height="auto" width="900" :scrollable="true" :clickToClose="true">
        <CloseModal :close="close"/>
        <div class="modalbox">
            <div class="modalbox-content">
                <div class="modal-header-info">
                    <div class="header-title">Histórico de Uso</div>
                </div>
                <div v-if="historico && historico.length" class="table-responsive">
                    <datatable
                        :columns="table.columns"
                        :data="historico"
                        class="table table-hover table-sm"
                    >
                    </datatable>
                </div>
                <EmptyState
                    v-else
                    icon="inbox"
                    title="Nenhum registro de uso encontrado"
                />
            </div>
        </div>
    </modal>
</template>

<script>
  import CloseModal from "../../components/CloseModal";
  import EmptyState from "../../components/EmptyState";

  export default {
    name: "cupomHistorico",
    components: {
      CloseModal,
      EmptyState,
    },
    props: [
      "historico",
      "close"
    ],
    data() {
      return {
        table: {
          columns: [
            {label: "Cliente", field: "cliente", align: "center", sortable: false},
            {label: "Data Uso", field: "datauso", align: "center", sortable: false},
            {label: "Pedido", field: "pedido_id", align: "center", sortable: false},
            {label: "Valor Pedido", field: "valortotal", align: "center", sortable: false},
            {label: "Desconto", field: "desconto", align: "center", sortable: false},
          ]
        }
      };
    },
    methods: {},
  };
</script>

<style scoped>
.modal-header-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #3a3e81;
}

</style>
